module.exports = __webpack_public_path__ + "static/media/main idea.8b4d4378.mp3";